import { Divider, Table, Spin, Select } from 'antd'
import { useEffect, useState } from 'react'
import { getTopUser } from 'src/api/game'
import { getSurvivalZone } from 'src/api/survivalzone'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { fetchCountryProvider } from 'src/api/authen'
import SurvivalZoneSelect from 'src/components/Search/SurvivalZoneSelect'

const SurvivalZoneLeaderBoard = () => {
  const [gameLoading, setSurvivalZoneLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [game, setSurvivalZone] = useState(undefined)
  const [transformedData, setTransformedData] = useState([])
  const [country, setCountry] = useState('')
  const [countries, setCountries] = useState([])
  const [games, setSurvivalZones] = useState([])

  const fetchCountry = async () => {
    try {
      const data = await fetchCountryProvider()
      const countryOptions = data.data.map((item) => ({
        label: item.countryName,
        value: item.countryCode,
      }))
      setCountries(countryOptions)

      if (countryOptions.length > 0) {
        setCountry(countryOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching country data:', error)
    }
  }

  const fetchSurvivalZone = async (searchValue = '', shouldSetFirst = true) => {
    try {
      setSurvivalZoneLoading(true)
      const data = await getSurvivalZone(0, 10, searchValue)
      const mazeOptions = data.data.map((item) => ({
        label: item.name,
        value: item.id,
      }))
      setSurvivalZones(mazeOptions)

      if (shouldSetFirst && mazeOptions.length > 0) {
        setSurvivalZone(mazeOptions[0].value)
      }
    } catch (error) {
      console.error('Error fetching maze s:', error)
    } finally {
      setSurvivalZoneLoading(false)
    }
  }

  const handleCountryChange = (value) => {
    setCountry(value)
  }

  const fetchTopScoresData = async (id, country) => {
    try {
      setLoading(true)
      const response = await getTopUser(id, country)
      const transformedData = response.data
      setTransformedData(transformedData)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCountry()
    fetchSurvivalZone('', true)
  }, [])

  useEffect(() => {
    if (game && country) {
      fetchTopScoresData(game, country)
    }
  }, [country, game])

  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      key: 'rank',
    },
    {
      title: 'User Name',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Points',
      dataIndex: 'points',
      key: 'points',
    },
  ]

  return (
    <>
      <Spin spinning={loading}>
        <SurvivalZoneSelect
          value={game}
          onChange={(value) => setSurvivalZone(value)}
        />

        <Select
          placeholder="Select Country"
          value={country}
          onChange={handleCountryChange}
          options={countries}
          style={{ width: '15%', marginLeft: '10px' }}
        />
        <Divider />
        <DndProvider backend={HTML5Backend}>
          <Table
            dataSource={transformedData}
            columns={columns}
            pagination={false}
          />
        </DndProvider>
      </Spin>
    </>
  )
}

export default SurvivalZoneLeaderBoard
